export const navLinks = [
  { id: "submit", label: "投稿入口", href: "#submit" },
  { id: "board", label: "曝光台", href: "#board" },
  { id: "ranking", label: "热度榜", href: "#ranking" },
  { id: "flow", label: "审核机制", href: "#flow" },
  { id: "privacy", label: "隐私保护", href: "#privacy" },
  { id: "faq", label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { id: "s1", value: "18,640", label: "累计收到线索" },
  { id: "s2", value: "92%", label: "匿名投稿占比" },
  { id: "s3", value: "48h", label: "平均审核时长" },
];

export const channels = [
  {
    id: "dm",
    icon: "ri-chat-private-line",
    title: "私信投稿",
    tag: "一对一通道",
    desc: "把线索私信发给社区值班编辑，全程点对点沟通，不公开、不挂号、不展示你的任何身份信息。",
    points: ["支持文字与图片材料", "可要求隐去敏感信息后再审", "编辑会先与你确认是否公开"],
    action: "复制投稿邮箱",
    note: "tougao@heiliao-community.cn",
  },
  {
    id: "board",
    icon: "ri-file-upload-line",
    title: "曝光台线索提交",
    tag: "自助提交",
    desc: "直接填写线索表单投递到曝光台，标题与摘要先进入待审队列，通过后才会出现在公开列表。",
    points: ["表单可不填联系方式", "可指定希望隐去的字段", "审核通过后自动生成线索编号"],
    action: "填写线索表单",
    note: "无需登录即可提交",
  },
];

export const flowSteps = [
  {
    id: "f1",
    step: "01",
    title: "匿名提交",
    desc: "私信或表单任选其一，提交时不会要求实名，也不会记录投稿人的公开身份信息。",
  },
  {
    id: "f2",
    step: "02",
    title: "编辑初筛",
    desc: "值班编辑先做敏感信息脱敏，判断线索是否具备可核实的方向，必要时回私信与你补充。",
  },
  {
    id: "f3",
    step: "03",
    title: "合规审核",
    desc: "对涉及个人隐私、未成年人、医疗等敏感内容做二次把关，不符合规范的线索不予展示。",
  },
  {
    id: "f4",
    step: "04",
    title: "展示与跟进",
    desc: "通过审核的线索进入曝光台列表，并按热度参与榜单排序，后续补充材料可随时追加。",
  },
];

export const boardItems = [
  {
    id: "b1",
    tag: "消费维权",
    title: "某连锁餐饮门店后厨卫生问题的连续反馈",
    summary: "多位用户先后提交同一门店的现场情况，编辑已整理为集中线索，等待运营复核。",
    heat: 9820,
    time: "12 分钟前",
    status: "已展示",
  },
  {
    id: "b2",
    tag: "教育培训",
    title: "暑期培训班退费拖延问题的集中投稿",
    summary: "涉及同一机构的退费沟通记录被多次提交，线索已合并归档并标注时间线。",
    heat: 7640,
    time: "1 小时前",
    status: "待补充",
  },
  {
    id: "b3",
    tag: "平台规则",
    title: "某电商售后规则调整后的自助申诉体验记录",
    summary: "投稿人整理了自己的申诉流程截图，编辑隐去订单信息后转入曝光台。",
    heat: 6210,
    time: "3 小时前",
    status: "已展示",
  },
  {
    id: "b4",
    tag: "社区治理",
    title: "小区公共区域费用公示不清晰的线索整理",
    summary: "线索以时间线方式提交，包含公示照片与沟通时间点，敏感信息已做统一脱敏。",
    heat: 5480,
    time: "6 小时前",
    status: "已展示",
  },
  {
    id: "b5",
    tag: "信息核实",
    title: "网络征询类信息真伪待核实的投稿提示",
    summary: "该线索涉及转述内容，编辑标注为待核实状态，暂不对外展开细节。",
    heat: 4130,
    time: "11 小时前",
    status: "待核实",
  },
];

export const hotRanking = [
  { id: "r1", rank: 1, title: "连锁餐饮后厨卫生问题集中反馈", heat: 9820, tag: "消费维权" },
  { id: "r2", rank: 2, title: "暑期培训班退费拖延集中投稿", heat: 7640, tag: "教育培训" },
  { id: "r3", rank: 3, title: "电商售后申诉流程体验记录", heat: 6210, tag: "平台规则" },
  { id: "r4", rank: 4, title: "小区公共费用公示不清线索", heat: 5480, tag: "社区治理" },
  { id: "r5", rank: 5, title: "网络征询类信息真伪待核实", heat: 4130, tag: "信息核实" },
];

export const hotTopics = [
  { id: "t1", label: "消费维权", count: 1284 },
  { id: "t2", label: "教育培训", count: 962 },
  { id: "t3", label: "平台规则", count: 874 },
  { id: "t4", label: "社区治理", count: 651 },
  { id: "t5", label: "信息核实", count: 538 },
  { id: "t6", label: "职场环境", count: 476 },
  { id: "t7", label: "服务投诉", count: 402 },
  { id: "t8", label: "公共安全", count: 355 },
];

export const privacyPoints = [
  {
    id: "p1",
    icon: "ri-user-forbid-line",
    title: "不要求实名",
    desc: "投稿全程无需注册实名账号，表单也允许不填写任何联系方式。",
  },
  {
    id: "p2",
    icon: "ri-eye-off-line",
    title: "敏感信息脱敏",
    desc: "编辑会在展示前隐去手机号、住址、证件等可定位到个人的内容。",
  },
  {
    id: "p3",
    icon: "ri-shield-check-line",
    title: "审核后才公开",
    desc: "线索先进待审队列，合规审核通过后才会进入曝光台列表。",
  },
  {
    id: "p4",
    icon: "ri-history-line",
    title: "补充材料可追溯",
    desc: "同一线索的后续补充会合并归档，方便运营持续跟进而不重复曝光。",
  },
];

export const faqs = [
  {
    id: "q1",
    question: "匿名投稿真的不会暴露身份吗？",
    answer:
      "投稿不需要注册实名账号，表单也将联系方式设为选填。编辑在展示前会统一做敏感信息脱敏，只保留线索本身的内容。",
  },
  {
    id: "q2",
    question: "私信投稿和曝光台提交有什么区别？",
    answer:
      "私信投稿是一对一沟通，适合需要先讨论细节的线索；曝光台提交是自助表单，适合材料已整理完整、希望直接进入待审队列的情况。两者都不需要登录。",
  },
  {
    id: "q3",
    question: "提交之后多久会被展示？",
    answer:
      "线索进入待审队列后，平均 48 小时内完成初筛与合规审核。若需要补充材料，编辑会通过你留下的联系方式回信确认。",
  },
  {
    id: "q4",
    question: "哪些内容不会被审核通过？",
    answer:
      "涉及个人隐私、未成年人、医疗等敏感领域，以及无法核实来源的转述内容，通常不会被公开展示，这也是为了保护爆料人和被提及方的安全。",
  },
  {
    id: "q5",
    question: "同一条线索被反复投稿会怎样？",
    answer:
      "系统会按主题做合并归档，重复线索不会重复占用曝光台位置，而是并入同一条目的时间线，方便集中跟进。",
  },
];